import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import _ from "lodash";
import api from "./api";
import * as util from "./utils.js";
import Roles from "@/roles";

// Global Directives
import "./directives";

// Global Plugins
import "./plugins";

// Global Components
import "./components";

// Global Styles
import "flex.box";
import "animate.css";
import "flag-icon-css/css/flag-icon.css";
import "../node_modules/@mdi/font/css/materialdesignicons.min.css";
import { IsInRole, IsInRoles } from "./utils";
import VueZoomer from "vue-zoomer";

Vue.config.productionTip = false;
Vue.prototype.$http = api;
Vue.prototype.$now = () => {
  const now = Date.now();
  const nowD = new Date(now);

  return nowD.toISOString();
};

api.defaults.timeout = 3 * 60 * 1000;
// This interceptor makes sure that every request has a token
// and if the token changes this also keeps it updated.
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("_token");
    if (token) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }

    const { CompanySelected, UserID } = store.state.user.user;
    config.params = {
      ...config.params,
      currentUserId: UserID,
      CompanySelected
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(function (response) {
  return response;
}, util.catchError);

Vue.set(Vue.prototype, "_", _);

// Funciones y campos calculados globales.
Vue.mixin({
  data() {
    return {
      roles: Roles
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.user.user;
    },
    currentCompany() {
      return this.$store.state.user.user.CompanySelected;
    }
  },
  methods: {
    IsInRole(rolename = "") {
      let roles = this.currentUser.Roles;
      return IsInRole(rolename, roles);
    },
    IsInRoles(rolesname = []) {
      let roles = this.currentUser.Roles;
      return IsInRoles(rolesname, roles);
    }
  }
});

Vue.filter("formatterMoney", (val) => {
  let f = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD"
  });
  let t = f.format(val);
  return t;
});
/*
Vue.filter("formatterPercentColors", val => {
 let clase = "";
  if (val < 80){
    clase = "Rojo"
  }

  return ;
});
*/
Vue.use(VueZoomer);

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
